import { Outlet } from "react-router";

/**
 * Public layout for unauthenticated users
 * Renders auth/public routes (login, register, etc.)
 */
const GuestLayout = () => {
  return <Outlet />;
};

export default GuestLayout;
